<script setup lang="ts">
import type { LatLngBounds, MapProvider } from '@gpx-spa/geo-domain';
import Expand from '@primeicons/vue/expand';
import Button from 'primevue/button';
import { computed, toRef } from 'vue';
import { useGpxMapProvider } from '../composables/useGpxMapProvider';

const props = withDefaults(
  defineProps<{
    mapProvider?: MapProvider;
    bounds: LatLngBounds;
    /** Overrides default "Fit map to bounds". */
    ariaLabel?: string;
    /** Tooltip / native title. */
    buttonTitle?: string;
  }>(),
  {
    ariaLabel: undefined,
    buttonTitle: undefined,
  },
);

const map = useGpxMapProvider(toRef(props, 'mapProvider'));

const ariaLabelResolved = computed(
  () => props.ariaLabel ?? 'Fit map to bounds',
);
const titleResolved = computed(
  () => props.buttonTitle ?? 'Fit all content',
);

function fit() {
  map.value.fitBounds(props.bounds);
}
</script>

<template>
  <Button
    rounded
    severity="contrast"
    size="small"
    :aria-label="ariaLabelResolved"
    :title="titleResolved"
    @click="fit"
  >
    <template #icon>
      <slot>
        <Expand />
      </slot>
    </template>
  </Button>
</template>
